import { Component } from '@angular/core';

@Component({
    selector: 'app-change-in-work-request-wrapper',
    templateUrl: './change-in-work-request-wrapper.component.html',
    styleUrls: ['./change-in-work-request-wrapper.component.scss'],
    standalone: false
})
export class ChangeInWorkRequestWrapperComponent {

}
